// this small wrapper exists to align badges in the Fleet View table cells properly,
// as centre them vertically was causing misalignment when badges had text under them
export const BadgeColumnContainer = ({ children }: { children: React.ReactNode }) => (
  <div className='flex h-11 items-start'>{children}</div>
);
